const SetupPluginLabel = () => (
    <>
        Setup plugin
    </>
);

export default SetupPluginLabel;
